var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.question.renderCssRoot },
    [
      _c(
        "div",
        { class: _vm.question.cssClasses.selectWrapper },
        [
          !_vm.question.isReadOnly
            ? _c(
                "div",
                {
                  class: _vm.question.getControlClass(),
                  attrs: {
                    tabindex: "0",
                    id: _vm.question.inputId,
                    "aria-required": _vm.question.ariaRequired,
                    "aria-label": _vm.question.ariaLabel,
                    "aria-invalid": _vm.question.ariaInvalid,
                    "aria-describedby": _vm.question.ariaDescribedBy,
                    required: _vm.question.isRequired,
                  },
                  on: { click: _vm.click },
                  model: {
                    value: _vm.question.renderedValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.question, "renderedValue", $$v)
                    },
                    expression: "question.renderedValue",
                  },
                },
                [_vm._v(_vm._s(_vm.question.readOnlyText))]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.question.isReadOnly
            ? _c("sv-popup", { attrs: { model: _vm.question.popupModel } })
            : _c(
                "div",
                {
                  class: _vm.question.getControlClass(),
                  attrs: { disabled: "", id: _vm.question.inputId },
                },
                [_vm._v(_vm._s(_vm.question.readOnlyText))]
              ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.question.isOtherSelected
        ? _c("survey-other-choice", { attrs: { question: _vm.question } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }